import React from 'react';

const Appliance = () => {

    return (
        <div>
            <h1 className="text-center">Home Appliance</h1>
        </div>
    )
}

export default Appliance;